import React from 'react'
import { RadioButtonChecked } from '@mui/icons-material'
import cn from '../../../../../lib/utils/cn'
import { MarketingFeature } from '../../../../../lib/api/types/billing.interfaces'

interface PlanFeaturesProps {
	features?: MarketingFeature[]
	isActive: boolean
}

const PlanFeatures: React.FC<PlanFeaturesProps> = ({ features, isActive }) => {
	return (
		<>
			{features?.map((feature, id) => (
				<p
					key={id}
					className={cn(
						'flex items-center gap-2.5 font-medium text-base dark:text-text-main-dark',
						isActive ? 'text-text-main' : 'text-text-secondary'
					)}
				>
					<RadioButtonChecked
						className={cn(
							'w-4 h-4',
							isActive
								? 'fill-accent'
								: 'fill-text-secondary dark:fill-text-main-dark'
						)}
					/>
					{feature.name}
				</p>
			))}
		</>
	)
}

export default PlanFeatures
